import React from 'react';
import './TopDropSkeleton.scss';

const TopDropSkeleton: React.FC = () => {
  return (
    <div className="top_drop_skeleton_wrapper">
      <div className="top_drop_skeleton">
        {/* Кнопки переключения Best/All drop */}
        <div className="top_drop_skeleton_btns">
          <div className="top_drop_skeleton_btn"></div>
          <div className="top_drop_skeleton_btn"></div>
        </div>
        
        {/* Контейнер для элементов дропа */}
        <div className="top_drop_skeleton_items">
          {/* Создаем 5 скелетонов для элементов */}
          {Array(15).fill(0).map((_, index) => (
            <div key={index} className="top_drop_skeleton_item"></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopDropSkeleton; 
